import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { RegisterService } from '../../service/Register/register.service';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { ExcelService } from '../../service/Excel/excel.service';
import { environment } from '../../../environments/environment';


@Component({
    selector: 'app-register-bulk-upload',
    templateUrl: './register-bulk-upload.component.html',
    styleUrl: './register-bulk-upload.component.scss'
})
export class RegisterBulkUploadComponent {
    Loader: boolean = false;
    selectAll: boolean = false;
    UploaditemformGroup!: FormGroup;
    buyers_ary: any;
    registerforSettings = {};
    registerfor_select: any;
    registerfor_name: any;
    usertype: any = 1;
    users: any[] = [];
    errorMessages: string[] = [];
    file: File | null = null;
    // maxRecordCount = 500;
    maxRecordCount: number = Number(environment.REGISTRATION_RECORD_LIMIT);
    maxFileSizeInBytes = 2 * 1024 * 1024; // 2MB
    error: string = '';

    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private registerService: RegisterService,
        private router: Router,
        private excelService: ExcelService
    ) {
        this.UploaditemformGroup = this.fb.group({
            register_for: ['', Validators.required],
            read_excel_data: ['', Validators.required],
        });
    }


    ngOnInit() {

        this.registerService.GetRegisteredSellers().subscribe({
            next: (res) => {
                this.buyers_ary = res.data;
            }, error: (err) => {
                this.toastr.error('Error Occured in RegisterFor Request', err);
            }
        });


        this.registerService.GetRegisteredSellers().subscribe({
            next: (res) => {
                this.buyers_ary = [];
                var buyers_data = res.data || [];
                buyers_data.forEach(child => {
                    this.buyers_ary.push({ 'id': child.user_id, 'itemName': child.company_name });
                });
                this.buyers_ary.push({ 'id': 0, 'itemName': 'Others' });
            }, error: (err) => {
                this.toastr.error('Error Occured in RegisterFor Request', err);
            }
        });

        this.registerforSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'itemName',
            allowSearchFilter: true,
            enableCheckAll: false,
            closeDropDownOnSelection: true,
        };
    }

    registerforSelect(items: any) {
        this.registerfor_select = items.id;
        this.registerfor_name = items.itemName;
    }

    Selecttype(event: any) {
        this.usertype = event.target.value;
    }

    onFileChange(event: any) {
        const target: DataTransfer = <DataTransfer>(event.target);
        if (target.files.length !== 1) {
            this.errorMessages.push('Please upload only one file at a time.');
            return;
        }
        this.file = target.files[0];
        // Check for file size (max 2MB)
        if (this.file.size > this.maxFileSizeInBytes) {
            this.errorMessages.push(`Error: File size should not exceed 2MB. Your file size is ${(this.file.size / (1024 * 1024)).toFixed(2)} MB.`);
            return;
        }

        if (this.file) {
            const fileExtension = this.file.name.split('.').pop()?.toLowerCase();

            // Validate the extension
            if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
                this.toastr.error('Invalid file format. Only .xlsx files are allowed.');
                // Clear the input if the file is not valid
                this.UploaditemformGroup.get('read_excel_data')?.setValue(null);
            }
        }

        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];
            const jsonData: any[] = XLSX.utils.sheet_to_json(ws, { header: 1 });

            // Validate number of records
            const recordsCount = jsonData.length - 1; // Subtract header row

            if (recordsCount > this.maxRecordCount) {
                this.errorMessages.push(`Error: Maximum (environment.REGISTRATION_RECORD_LIMIT) records are allowed. Your file has ${recordsCount} records.`);
                return;
            }

            // Parse the Excel file and convert to JSON
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
            this.processData(data);
        };
        reader.readAsBinaryString(target.files[0]);
        event.target.value = '';
    }

    processData(data: any[]) {

        this.users = [];
        this.errorMessages = [];

        // Define the expected headers
        const expectedHeaders = ['Buyer_Type', 'GST_Number', 'Company_Name', 'Vendor_Code', 'Contact_Person_Name', 'Mobile_Number', 
            'Mail_Id','Industry', 'Country', 'Region', 'Terms_Condition'];

        // Get the actual headers from the first row of the file
        const actualHeaders = data[0];

        // Check if the headers match
        if (!this.validateHeaders(actualHeaders, expectedHeaders)) {
            this.errorMessages.push('Invalid file format.');
            this.UploaditemformGroup.controls['read_excel_data'].setValue(['']);
            return;
        }

        const gstSet = new Set();  // To track unique gst
        const mobileSet = new Set(); // To track unique mobile numbers
        const emailSet = new Set();  // To track unique emails
        const vendorCode = new Set();  // To track unique reference_id



        // Assuming first row contains headers: ['Name', 'Email', 'Mobile']
        data.forEach((row, index) => {

            if (index === 0) return; // Skip header row

            const Buyer_Type = row[0];
            const GST_Number = row[1] == undefined ? null : row [1];
            const Company_Name = row[2] == undefined ? null : row [2];
            const Vendor_Code = row[3] == undefined ? null : row[3];
            const Contact_Person_Name = row[4];
            const Mobile_Number = row[5];
            const Mail_Id = row[6] == undefined ? null : row[6];
            const Industry = row[7] == undefined ? null : row[7];
            const Country = row[8] || 'India';
            const Region = row[9];
            const Terms_Condition = row[10];
            this.error = '';

            // // Basic validation
            // if (!Buyer_Type || !GST_Number || !Contact_Person_Name || !Mobile_Number || !Region || !Terms_Condition ) {
            //  this.error = `Missing required fields,`;
            // }

            // Basic validation (GST_Number is optional for Retailers)
            if (!Buyer_Type || !Contact_Person_Name || !Mobile_Number || !Region || !Terms_Condition) {
                this.error += ` Missing required fields,`;
            }

            // Ensure GST_Number is required **only if** Buyer_Type is NOT 'Retailer'
            // if (Buyer_Type !== 'Retailer' && !GST_Number) {
            //     this.error += ` GST Number is required for Dealer,`;
            // }

            if (!Contact_Person_Name) {
                this.error += ` Contact Person Name is required,`;
            }
            if (!Region) {
                this.error += ` Region is required,`;
            }
            if (!Terms_Condition) {
                this.error += ` Terms Condition is required,`;
            }
            if (!GST_Number && !Company_Name) {
                this.error += ` Company Name is required,`;
            }
            
            // GST validation (Only if GST_Number is provided)
            if (GST_Number && !this.validateGST(GST_Number)) {
                this.error += ` Invalid GST number format (${GST_Number}),`;
            }
             // // GST number validation
            // if (!this.validateGST(GST_Number)) {
            //   this.error = this.error+` Invalid GST number format (${GST_Number}),`;
            // }

            // Email format validation
            if (!this.validateEmail(Mail_Id) && Mail_Id) {
                this.error = this.error + ` Invalid email format,`;
            }

            // Mobile number validation: Ensure it's digits and has a length of 10 digits
            if (!this.validateMobile(Mobile_Number)) {
                this.error = this.error + ` Invalid mobile number format (should be 10 digits),`;
            }


            // Duplicate GST check
            if (GST_Number) {
                if (gstSet.has(GST_Number)) {
                    this.error += ` Duplicate GST Number (${GST_Number}),`;
                } else {
                    gstSet.add(GST_Number);
                }
            }

            // Duplicate email check
            if (emailSet.has(Mail_Id) && Mail_Id) {
                this.error = this.error + ` Duplicate Mail Id (${Mail_Id}),`;
            } else {
                emailSet.add(Mail_Id);
            }

            // Duplicate mobile check
            if (mobileSet.has(Mobile_Number)) {
                this.error = this.error + ` Duplicate Mobile Number (${Mobile_Number}),`;
            } else {
                mobileSet.add(Mobile_Number);
            }

            // Duplicate Vendor Code check
            if (Vendor_Code != null && vendorCode.has(Vendor_Code)) {
                this.error = this.error + ` Duplicate Vendor Code(${Vendor_Code}),`;
            } else {
                vendorCode.add(Vendor_Code);
            }

            // T&C validation: Only accept rows where T&C is 'accept'
            // if (Terms_Condition.toLowerCase().trim() !== 'accept') {
            //     this.error = this.error + ` T&C value must be 'accept',`;
            // }
            if (this.error) {
                this.errorMessages.push(`Row ${index + 1} : ` + this.error);
            }

            // If all validations pass, add the user to the users array
            this.users.push({ Buyer_Type, GST_Number, Company_Name, Vendor_Code, Contact_Person_Name, Mobile_Number, Mail_Id, Industry, Country, Region, Terms_Condition });
        });

    }

    validateHeaders(actualHeaders: string[], expectedHeaders: string[]): boolean {
        // Check if both arrays have the same length
        if (actualHeaders.length !== expectedHeaders.length) {
            return false;
        }

        // Check if every header in the expectedHeaders matches the actualHeaders
        for (let i = 0; i < expectedHeaders.length; i++) {
            if (actualHeaders[i].trim().toLowerCase() !== expectedHeaders[i].trim().toLowerCase()) {
                return false;
            }
        }

        return true;
    }

    validateEmail(email: string): boolean {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    validateMobile(mobile: string): boolean {
        const re = /^[0-9]{10}$/;  // Adjust regex for specific country if necessary
        return re.test(mobile);
    }

    validateGST(gst: string): boolean {
        const re = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
        return re.test(gst);
    }

    // Trigger Excel download
    exportData(dataArray: any[]) {
        setTimeout(() => {
            this.excelService.exportAsExcelFile(dataArray, 'users_data');
        }, 3000);
    }

    onSubmit() {
        this.Loader = true;
        if (this.UploaditemformGroup.valid) {

            if (this.errorMessages.length > 0) {
                alert('Please fix the errors before submitting');
                return;
            }

            const formData = new FormData();
            formData.append('usertype', this.usertype);
            formData.append('register_for', this.registerfor_select);
            formData.append('users', JSON.stringify(this.users));

            // formData.forEach((value, key) => {
            //   console.log(key + ': ' + value);
            // });

            this.registerService.bulkUploadRegister(formData).subscribe({
                next: (res) => {
                    this.Loader = false;
                    if (res.status == "success") {
                        if (res.data.length > 0) {
                            this.exportData(res.data);
                        }
                        this.toastr.success(res.message);
                        this.UploaditemformGroup.reset();
                        this.users = []
                        this.ngOnInit();
                    } else {
                        this.toastr.error('error');
                    }
                }, error: (err) => {
                    this.Loader = false;
                    if (err.error.status == 'error') {
                        if (err.error.data.length > 0) {
                            this.exportData(err.error.data);
                        }
                        this.toastr.error(err.error.message);
                        return
                    }
                    if (err.error.status == 'duplicate') {
                        err.error.duplicate.forEach((element: any) => {
                            this.toastr.error(element.duplicateColumn);
                        });
                        return
                    }
                }
            });
        } else {
            // Handle form errors
            this.UploaditemformGroup.markAllAsTouched();
            this.Loader = false;

        }
    }
}
